export const KEY_GET_PAYMENTS = 'get.payments.call';
export const KEY_GET_PENDING_PAYMENTS = 'get.pending-payments.call';
export const KEY_GET_DOWNLOAD_PAYMENT_RECEIPT = 'get.download-payment-receipt.call';
export const KEY_POST_PAYMENTS_CREATE = 'post.payments-create.call';
